import React from 'react';
import Link from '@material-ui/core/Link';

import ImgModal from '../../../components/ImgModal/ImgModal';
import s from './OtherGoods.module.scss';
// import goUp from '../../../utilities/goUp';

const OtherGoodsItem = props => {
  const { id, image, name, description, price, t } = props;

  return (
    <div className={s.main}>
      <ImgModal image={image} />
      <div className={s.description}>
        <Link href={`/good/${id}`} color="inherit">
          <h4>{name}</h4>
        </Link>
        {description}
        <div className={s.price}>
          {t.language === 'ru' ? `${price} ₽` : null}
        </div>
      </div>
    </div>
  );
};

export default OtherGoodsItem;
